import { AttachedBundle, AttachedCampaign, AttachedPromotionSchedule } from '~/services/AccommodationService';

const isScheduleCurrentlyActive = (schedule: AttachedPromotionSchedule, today: string): boolean =>
  schedule.activeStartDate != null &&
  schedule.activeEndDate != null &&
  schedule.activeStartDate <= today &&
  today <= schedule.activeEndDate;

// Mirrors hasCurrentlyActiveSchedule in svc-accommodation's campaign/bundle DAL: a promotion with
// no schedules at all has nothing to restrict it, so it's unconditionally live (status/isActive
// alone gate it); a promotion with schedules is live only while one of them is in its active
// period today.
export function hasCurrentlyActiveSchedule(schedules: Array<AttachedPromotionSchedule>): boolean {
  if (schedules.length === 0) {
    return true;
  }

  const today = new Date().toISOString().slice(0, 10);
  return schedules.some((schedule) => isScheduleCurrentlyActive(schedule, today));
}

export function isBundleCurrentlyLive(bundle: AttachedBundle): boolean {
  return bundle.status === 'content-approved' && bundle.isActive && hasCurrentlyActiveSchedule(bundle.schedules);
}

export function isCampaignCurrentlyLive(campaign: AttachedCampaign): boolean {
  return campaign.status === 'active' && hasCurrentlyActiveSchedule(campaign.schedules);
}

// Prefers whichever schedule is actually keeping the promotion live today, since a promotion can
// have multiple schedules and always showing schedules[0] can display a stale/expired window while
// a later schedule is the one currently making it live.
export function formatScheduleWindow(schedules: Array<AttachedPromotionSchedule>): string | null {
  if (schedules.length === 0) {
    return null;
  }

  const today = new Date().toISOString().slice(0, 10);
  const schedule = schedules.find((s) => isScheduleCurrentlyActive(s, today)) ?? schedules[0];
  if (!schedule.activeStartDate || !schedule.activeEndDate) {
    return null;
  }

  return `${schedule.activeStartDate} to ${schedule.activeEndDate}`;
}
